// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

/**
 * @class Jsw.FileManager.UploadAdapterIframe
 */
export const UploadAdapterIframe = Class.create({
    initialize(config) {
        this._contentAreaId = config.contentAreaId;
        this._handlerUrl = config.handlerUrl;
        this._startUploadHandler = config.startUploadHandler;
        this._finishUploadHandler = config.finishUploadHandler;
        this._uploadFrameInitialized = false;
        this._getUploadIFrameElement();
    },

    _getUploadIFrameElement() {
        if (!$(this._contentAreaId).down('iframe')) {
            this._uploadFrameElement = new Element('iframe', {
                id: `${this._contentAreaId}-upload-iframe`,
                name: '_uploadIFrame',
                style: 'display: none;',
                src: this._handlerUrl,
            });
            $(this._contentAreaId).insert(this._uploadFrameElement);
            this._uploadFrameElement.observe('load', this._onUploadFrameInitialized.bindAsEventListener(this));
        }
        return this._uploadFrameElement;
    },

    _onUploadFrameInitialized() {
        if (this._uploadFrameInitialized) {
            return;
        }
        this._uploadFrameInitialized = true;
        this._uploadFrameElement.observe('load', this._finishUploadHandler);
        this._startUploadHandler();
    },

    isReady() {
        return this._uploadFrameInitialized;
    },

    getResult() {
        const statusFrame = this._getUploadIFrameElement();
        const statusDocument = statusFrame.contentDocument || statusFrame.contentWindow.document;
        try {
            return statusDocument.body.innerHTML.evalJSON();
        } catch (e) {
            return {
                status: 'ERROR',
                message: 'No upload response',
            };
        }
    },

    cancel() {
        if (this._uploadFrameElement) {
            this._uploadFrameElement.setAttribute('src', 'javascript:false;');
        }
        this._finishUploadHandler();
    },
});



// WEBPACK FOOTER //
// ./jsw/file-manager/upload-adapter-iframe.js